export const blog = {
  // Bare name; the brand suffix is composed at the call site.
  // A literal `|` here is read by vue-i18n as a plural delimiter.
  pageTitle: 'Blog',
  metaDescription: 'Wissen rund um Kubernetes, Cloud Hosting und Container-Technologien. Praxisnahe Artikel für Entwickler und IT-Entscheider.',
  heading: 'Blog',
  subtitle: 'Wissen rund um Kubernetes, Cloud und Container-Technologien.',
  readMore: 'Weiterlesen',
  publishedOn: 'Veröffentlicht am {date}',
  minuteRead: '{n} Min. Lesezeit',
  backToBlog: 'Zurück zum Blog',
  noPosts: 'Noch keine Beiträge vorhanden.',
  tags: 'Tags',
  allPosts: 'Alle Beiträge',
  by: 'von'
} as const
